<script>
    import { localStorageWritable } from "@babichjacob/svelte-localstorage";
    import LeftMenuButton from "../left-menu/Button.svelte";
    import LeftMenuAvatar from "../left-menu/Avatar.svelte";
    import Home from "../../pages/Home.svelte"; // Needed for views array if we keep it, otherwise remove?
    // We removed views export, so we don't need page imports here except what's used.
    // We need icons.

    import HomeIcon from "../../icons/home.svg";
    import BookmarkIcon from "../../icons/bookmark.svg";
    import FriendsIcon from "../../icons/friends.svg";
    import DiscoverIcon from "../../icons/discover.svg";
    import SearchIcon from "../../icons/search.svg";
    import NotificationIcon from "../../icons/notification.svg";
    import SettingsIcon from "../../icons/settings.svg";
    import CollectionIcon from "../../icons/collection.svg";
    import NotifiactionAvaliable from "../../icons/notificationAvaliable.svg";

    import Notifications from "../../pages/Notifications.svelte";
    import { notificationCount } from "../stores/notificationCount";

    import { location, push } from "svelte-spa-router";

    // Deprecated exports removed

    let utoken;

    $: nCount = $notificationCount;
    // Simple check for active route.
    // exact=true not supported by this simple check, but enough for menu.
    $: activeRoute = $location;

    const user_token = localStorageWritable("user_token", null);
    user_token.subscribe((value) => (utoken = JSON.parse(value)));

    // updateViewportComponent is now deprecated in App.svelte, so we don't define it here.

    let myProfile = anixApi.profile.info(utoken?.id);
</script>

{#snippet defaultAvatar(callback)}
    <LeftMenuAvatar
        onClickCallback={callback}
        avatar="./assets/icons/defaultAvatar.svg"
    />
{/snippet}

<div
    class="left-menu menu-hidden unselectable"
    class:hide={activeRoute.includes("/player")}
>
    <div class="top-menu-content">
        {#if !utoken}
            {@render defaultAvatar(() => push("/sign-in"))}
        {:else}
            {#await myProfile}
                {@render defaultAvatar(null)}
            {:then p}
                <LeftMenuAvatar
                    onClickCallback={() => push(`/profile/${utoken.id}`)}
                    avatar={p.profile.avatar}
                />
            {/await}
        {/if}

        <LeftMenuButton
            icon={HomeIcon}
            selected={activeRoute === "/" || activeRoute === "/home"}
            href="/home"
        />
        <LeftMenuButton
            icon={BookmarkIcon}
            selected={activeRoute === "/bookmarks"}
            href="/bookmarks"
        />
        <LeftMenuButton
            icon={FriendsIcon}
            selected={activeRoute === "/friends"}
            href="/friends"
        />
        <LeftMenuButton
            icon={CollectionIcon}
            selected={activeRoute === "/collections"}
            href="/collections"
        />
        <LeftMenuButton
            icon={DiscoverIcon}
            selected={activeRoute === "/discover"}
            href="/discover"
        />
        <LeftMenuButton
            icon={SearchIcon}
            selected={activeRoute.startsWith("/search")}
            href="/search"
        />
    </div>
    <div class="bottom-menu-content">
        <LeftMenuButton
            icon={nCount > 0 ? NotifiactionAvaliable : NotificationIcon}
            modalComponent={Notifications}
            type="modal"
        />
        <LeftMenuButton
            icon={SettingsIcon}
            selected={activeRoute === "/settings"}
            href="/settings"
        />
    </div>
</div>

<style>
    .left-menu {
        display: flex;
        flex-direction: column;
        height: 100%;
        background-color: var(--alt-background-color);
        align-items: center;
        overflow: hidden;
        z-index: 10;
    }

    .top-menu-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
    }

    .bottom-menu-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: auto;
        width: 100%;
        margin-bottom: 20px;
    }

    .menu-hidden {
        width: 75px;
        min-width: 75px;
    }
</style>
